'use client'

import { usePathname, useRouter } from 'next/navigation'
import { useTranslation } from 'react-i18next'
import { ArrowLeft } from '@peacecover/icon'

const HeaderWithBackButton = () => {
  const pathname = usePathname()
  const router = useRouter()

  const { t: tFaq } = useTranslation('faq')
  const { t: tNotice } = useTranslation('notice')
  const { t: tTerms } = useTranslation('terms')

  const handleBack = () => {
    router.back()
  }

  const getTitle = () => {
    if (pathname === '/faq/') return tFaq('faq_header')
    if (pathname === '/notice/') return tNotice('notice_header')
    if (pathname === '/terms/') return tTerms('terms_header')
    return null
  }

  const title = getTitle()

  return (
    <div className="py-3 px-4 mb-[18px] relative flex items-center">
      <button type="button" onClick={handleBack} className="flex-none">
        <ArrowLeft className='text-text-main-lv1' />
      </button>

      {title && (
        <h2 className="absolute left-1/2 transform -translate-x-1/2 text-[17px] font-pretendard-bold dark:text-white">
          {title}
        </h2>
      )}
    </div>
  )
}

export default HeaderWithBackButton
